module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "querty_content queryCourse coursewareModle commonAddcourse"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n    "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ManageMeeting'
      }
    }
  }, [_vm._v("专题读片")])], 1), _vm._v(" >\n    "), _c('span', [_vm._v("进入会议")])]), _vm._v(" "), _c('div', {
    staticClass: "w98 course_query"
  }, [_c('div', {
    staticClass: "course_top"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', {
    staticClass: "manageTitle",
    staticStyle: {
      "width": "120px",
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "title": _vm.detailList.confName
    }
  }, [_vm._v(_vm._s(_vm._f("lengthControl")(_vm.detailList.confName)))]), _vm._v(" "), _c('span', {
    staticClass: "managesm"
  }, [_vm._v(_vm._s(this.detailList.openFlag))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    staticClass: "playback",
    on: {
      "click": _vm.closeTopicConf
    }
  }, [_vm._v("结束会议")]), _vm._v(" "), _c('el-button', {
    staticClass: "playback",
    on: {
      "click": _vm.startView
    }
  }, [_vm._v("开启视频")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("主持人：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(this.detailList.host))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("会议名称：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content  info_contentName",
    staticStyle: {
      "width": "120px",
      "overflow": "hidden",
      "word-break": "break-all",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    },
    attrs: {
      "title": _vm.detailList.confName
    }
  }, [_vm._v(_vm._s(_vm._f("lengthControl")(this.detailList.confName)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("会议时间：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(this.detailList.confTime))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remarkTxt"
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("参会人员：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content dif_info",
    attrs: {
      "title": this.sendList
    }
  }, [_vm._v(_vm._s(this.sendListlitte))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    staticClass: "members fr"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.memberCount,
      "max": 99
    }
  }, [_vm._v("\n           实际到会\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right item"
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.attendList), function(item) {
    return _c('el-dropdown-item', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item.docName))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "20px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "query_medicalRecord_left"
  }, [_c('tabs', {
    attrs: {
      "activeName": '0'
    },
    on: {
      "tabChange": _vm.tabChange
    }
  }, [_c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "0"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("附件(" + _vm._s(_vm.attachList.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "fj_contents"
  }, [_c('div', {
    staticClass: "list_title list_file_title"
  }, [_vm._v("\n                文件类型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left_file_content"
  }, [(_vm.fileList.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_vm._v("暂无上传文件")]) : _c('div', _vm._l((_vm.fileList), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "file_row",
      class: {
        check: index == _vm.fileI
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('file', item, index)
        }
      }
    }, [_vm._v(_vm._s(item.attach_name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "list_title list_file_title"
  }, [_vm._v("\n                其他图片\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left_file_content"
  }, [(_vm.picList.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_vm._v("暂无上传图片")]) : _c('div', _vm._l((_vm.picList), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "file_row2",
      class: {
        check: index == _vm.picI
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('img', item, index)
        }
      }
    }, [_vm._v(_vm._s(item.attach_name))])
  }), 0)])])]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("影像(" + _vm._s(_vm.studyList.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "medicalList"
  }, [_c('reportTable', {
    staticClass: "img-table",
    attrs: {
      "data": _vm.data1,
      "head": _vm.head1
    },
    on: {
      "showDetial": _vm.studyShowDetials
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("病例(" + _vm._s(_vm.caseList.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "medicalList selectClick dif_select"
  }, [_c('reportTable', {
    attrs: {
      "head": _vm.head,
      "data": _vm.data
    },
    on: {
      "showDetial": _vm.showDetial
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_right query_course"
  }, [(_vm.isImage === '1') ? _c('div', {
    staticClass: "reportContent"
  }, [_c('h2', [_c('b', [_vm._v(_vm._s(_vm.reportInfo.examTypeName))]), _vm._v("报告单\n            "), _c('i', {
    staticClass: "btn btn2"
  }, [_vm._v("电子病历")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmY),
      expression: "readFilmY"
    }],
    staticClass: "btn",
    on: {
      "click": _vm.readFilm
    }
  }, [_vm._v("阅片")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmN),
      expression: "readFilmN"
    }],
    staticClass: "btn1"
  }, [_vm._v("阅片")]), _vm._v(" "), _c('i', {
    staticClass: "btn btn3",
    on: {
      "click": _vm.getReport
    }
  }, [_vm._v("电子申请单")])]), _vm._v(" "), _c('report', {
    attrs: {
      "info": _vm.reportInfo
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImage === '0') ? _c('div', {
    staticClass: "file_area"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailShow),
      expression: "detailShow"
    }]
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": require("../../../../static/image/defaultpic.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "23px",
      "text-align": "center"
    }
  }, [_vm._v("暂无内容")])]), _vm._v(" "), (_vm.imgShow == '2') ? _c('div', {
    staticClass: "img_area"
  }, [_c('img', {
    attrs: {
      "src": _vm.fileUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.showBigImg()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imgShow == '1') ? _c('div', {
    staticClass: "file_show"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("暂不支持预览，请点击下载")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.fileUrl
    }
  }, [_vm._v("下载")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isImage === '2') ? _c('div', [_c('div', {
    staticClass: "tabTwo"
  }, [_c('tabs', {
    attrs: {
      "activeName": '0'
    },
    on: {
      "tabChange": _vm.tabChangeRight
    }
  }, _vm._l((_vm.tabsRight), function(tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      attrs: {
        "label": tab.label,
        "name": tab.name
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isImageTwo === '0'),
        expression: "isImageTwo === '0'"
      }]
    }, [_c('medicalNewsDetail', {
      ref: "child",
      refInFor: true,
      attrs: {
        "detailList": _vm.medicalDetail
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isImageTwo === '1'),
        expression: "isImageTwo === '1'"
      }],
      staticClass: "dif_select"
    }, [_c('p-table', {
      attrs: {
        "head": _vm.head2,
        "data": _vm.data2,
        "operation": _vm.operation,
        "operationWidth": _vm.operationWidth
      },
      on: {
        "_operation": _vm._operation_
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isImageTwo === '2'),
        expression: "isImageTwo === '2'"
      }]
    }, [_c('uploadDetail', {
      attrs: {
        "updateFileList": _vm.updateFileList,
        "updatePicList": _vm.updatePicList
      }
    })], 1)])
  }), 1)], 1)]) : _vm._e()])])]), _vm._v(" "), (_vm.repShow) ? _c('pops', {
    staticClass: "collect",
    attrs: {
      "show": _vm.repShow,
      "width": _vm.popwidth,
      "title": _vm.title,
      "classes": 'Collections'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('elcRep', {
    attrs: {
      "elcRep": _vm.elcRep
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filePop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.filePop,
      "title": '',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeFile
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fileUrl,
      "width": "100%",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5209ace6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/manageMeeting/enterManageMeeting.vue
// module id = 567
// module chunks = 1 2 3 4 5 6 7 8